import { DisplayPosition } from '@/type/display-position';
// import {
//   CnTimePickerPro,
//   componentMap as formComponentMap,
// } from '@cainiaofe/cn-ui-m';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '时间选择',
    componentName: 'CnTimePickerPro',
    // component: CnTimePickerPro,
    // formComponent: formComponentMap.CnTimePickerPro,
    getFormItemDefaultProps: () => {
        return {};
    },
    getPrototypeList: () => {
        return [
            {
                name: 'format',
                title: '前端显示格式',
                display: 'inline',
                setter: {
                    componentName: 'SelectSetter',
                    props: {
                        options: [
                            {
                                label: 'HH:mm',
                                value: 'HH:mm',
                            },
                            {
                                label: 'mm:ss',
                                value: 'mm:ss',
                            },
                            {
                                label: 'HH:mm:ss',
                                value: 'HH:mm:ss',
                            },
                        ],
                    },
                },
            },
            // {
            //   name: 'outputFormat',
            //   title: '输出格式',
            //   display: 'inline',
            //   setter: {
            //     componentName: 'SelectSetter',
            //     props: {
            //       options: [
            //         {
            //           label: '时间戳',
            //           value: '',
            //         },
            //         {
            //           label: 'HH:mm',
            //           value: 'HH:mm',
            //         },
            //         {
            //           label: 'mm:ss',
            //           value: 'mm:ss',
            //         },
            //         {
            //           label: 'HH:mm:ss',
            //           value: 'HH:mm:ss',
            //         },
            //       ],
            //     },
            //   },
            // },
        ];
    },
};
